export default "__VITE_ASSET__QZE$zypQ__"